import LanguagesApi from '../../../core/api/LanguagesApi'
export const events = {
  edit: {
    start: 'START_EDITING_LANGUAGES',
    stop: 'STOP_EDITING_LANGUAGES',
    cancel: 'CANCEL_EDITING_LANGUAGES'
  },
  fetch: {
    fetched: 'ADVISER_LANGUAGE_PREFERENCES_FETCHED_LANGUAGES'
  },
  set: {
    selectionChanged: 'ADVISER_LANGUAGE_PREFERENCES_LANGUAGE_SELECTED_CHANGED'
  }
}

const languagesApi = new LanguagesApi()
const { edit, fetch, set } = events
export const actions = {
  edit: {
    start: () => ({
      type: edit.start
    }),
    stop: () => ({
      type: edit.stop
    }),
    cancel: () => ({
      type: edit.cancel
    })
  },
  fetch: {
    languages: () => {
      return async (dispatch) => {
        try {
          const response = await languagesApi.fetchingLanguages();
          dispatch({ 
            type: fetch.fetched, 
            payload: response })
            return response
        }
        catch (err) {
          dispatch({
            type: fetch.fetched,
            payload: []
          })
          throw err
        }
      }
    }
  },
  set: {
    selectionChanged: (language) => ({
      type: set.selectionChanged,
      language
    })
  }
}
